/**
 * <mejoris-gallery> — Galería grande del Sistema Mejoris.
 * Imagen principal + miniaturas. Componente de sistema, independiente,
 * reutilizable en cualquier landing (igual que <mejoris-carousel> y
 * <mejoris-purchase>).
 *
 * Uso (ver snippets/mejoris-gallery.liquid para el render completo):
 *   <mejoris-gallery class="mg">
 *     <div class="mg__main">
 *       <img class="mg__main-img" data-mg-main-img src="..." alt="...">
 *     </div>
 *     <div class="mg__thumbs">
 *       <button type="button" class="mg__thumb is-active" data-mg-thumb data-full="...">
 *         <img src="..." alt="">
 *       </button>
 *       ...
 *     </div>
 *   </mejoris-gallery>
 *
 * Se sincroniza automáticamente con <mejoris-purchase>: cuando el
 * usuario cambia de color/variante ahí, se dispara un evento
 * `mejoris:gallery-set-image` en `document` con `{ detail: { url } }`,
 * y esta galería cambia su imagen principal (y resalta la miniatura
 * correspondiente si existe una con ese mismo `data-full`). No hay
 * referencia directa entre los dos componentes — se comunican solo por
 * este evento, así cualquiera de los dos puede usarse solo.
 */
(function () {
  if (customElements.get('mejoris-gallery')) return;

  var SYNC_EVENT = 'mejoris:gallery-set-image';

  var SWIPE_THRESHOLD = 40;

  class MejorisGallery extends HTMLElement {
    connectedCallback() {
      this.mainImg = this.querySelector('[data-mg-main-img]');
      this.mainWrap = this.querySelector('.mg__main');
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-mg-thumb]'));
      this.prevBtn = this.querySelector('[data-mg-prev]');
      this.nextBtn = this.querySelector('[data-mg-next]');
      this.activeIndex = 0;

      var self = this;
      this.thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () { self._setImage(thumb.getAttribute('data-full'), thumb); });
      });

      if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self._go(-1); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self._go(1); });

      if (this.mainWrap) {
        this._touchStartX = null;
        this._touchStartY = null;
        this.mainWrap.addEventListener('touchstart', function (e) {
          if (!e.touches || e.touches.length !== 1) return;
          self._touchStartX = e.touches[0].clientX;
          self._touchStartY = e.touches[0].clientY;
        }, { passive: true });
        this.mainWrap.addEventListener('touchend', function (e) {
          if (self._touchStartX === null) return;
          var touch = e.changedTouches && e.changedTouches[0];
          if (touch) {
            var dx = touch.clientX - self._touchStartX;
            var dy = touch.clientY - self._touchStartY;
            if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
              self._go(dx < 0 ? 1 : -1);
            }
          }
          self._touchStartX = null;
          self._touchStartY = null;
        }, { passive: true });
      }

      this._onSync = function (e) {
        if (e && e.detail && e.detail.url) self._setImage(e.detail.url);
      };
      document.addEventListener(SYNC_EVENT, this._onSync);

      this._updateArrows();
    }

    disconnectedCallback() {
      document.removeEventListener(SYNC_EVENT, this._onSync);
    }

    _go(delta) {
      if (!this.thumbs.length) return;
      var next = this.activeIndex + delta;
      if (next < 0) next = 0;
      if (next > this.thumbs.length - 1) next = this.thumbs.length - 1;
      if (next === this.activeIndex) return;
      var thumb = this.thumbs[next];
      this._setImage(thumb.getAttribute('data-full'), thumb);
    }

    _updateArrows() {
      if (this.prevBtn) this.prevBtn.disabled = this.activeIndex <= 0;
      if (this.nextBtn) this.nextBtn.disabled = this.activeIndex >= this.thumbs.length - 1;
    }

    _setImage(url, activeThumb) {
      if (!url || !this.mainImg) return;
      this.mainImg.src = url;
      var idx = -1;
      this.thumbs.forEach(function (t, i) {
        var match = activeThumb ? t === activeThumb : t.getAttribute('data-full') === url;
        t.classList.toggle('is-active', match);
        if (match) idx = i;
      });
      if (idx !== -1) this.activeIndex = idx;
      this._updateArrows();
    }
  }

  customElements.define('mejoris-gallery', MejorisGallery);
})();
